var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorProposedCost(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53363_30334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.20312 11.1201C1.20313 9.95073 1.66766 8.82923 2.49454 8.00235C3.32142 7.17547 4.44291 6.71094 5.6123 6.71094C6.49556 6.71094 7.35149 6.97596 8.07379 7.46196",
    stroke: "#71819B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61132 6.70702C7.23474 6.70702 8.55077 5.39099 8.55077 3.76757C8.55077 2.14416 7.23474 0.828125 5.61132 0.828125C3.98791 0.828125 2.67188 2.14416 2.67188 3.76757C2.67188 5.39099 3.98791 6.70702 5.61132 6.70702Z",
    stroke: "#71819B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1431 13.0831C11.7668 13.0831 13.0831 11.7668 13.0831 10.1431C13.0831 8.51941 11.7668 7.20312 10.1431 7.20312C8.51941 7.20312 7.20312 8.51941 7.20312 10.1431C7.20312 11.7668 8.51941 13.0831 10.1431 13.0831Z",
    stroke: "#71819B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92188 10.1412L9.735 10.9544L11.3612 9.32812",
    stroke: "#71819B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53363_30334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorProposedCost);
export default __webpack_public_path__ + "static/media/vendorProposedCost.e51287715c080d4deaf96e1d763461d9.svg";
export { ForwardRef as ReactComponent };